import { GameFrame } from '@/features/game-client/game-frame';
import { gameContextSelector } from '@/features/game-context/store/game-context';
import { buildIgtUrl } from '@/features/providers/igt/igt-url-builder';
import { FGPIgtLaunchData } from '@/features/providers/igt/types';
import { GameDataProp } from '@/features/providers/types';
import { useAppSelector } from '@/store/hooks';

export const Igt: React.FC<GameDataProp> = ({ data }: GameDataProp) => {
  const url = buildIgtUrl(data as FGPIgtLaunchData);
  const { gameName } = useAppSelector(gameContextSelector);

  return <GameFrame title={gameName} url={url} />;
};
